import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors, resetPassword } from '../../redux/actions/userAction';
import { toast } from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Form, InputGroup } from 'react-bootstrap';
import SectionHeading from '../common/SectionHeading';
import { AiFillLock, AiFillUnlock } from 'react-icons/ai';
import Loader from '../common/Loader';
import MetaData from '../MetaData';

const ResetPassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let { token } = useParams();
    const { error, success, loading } = useSelector((state) => state.forgotPassword);

    const [passwordDetails, setPasswordDetails] = useState({
        password: '',
        confirmPassword: '',
    });

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }

        if (success) {
            toast.success('Password Updated Successfully');
            navigate('/login');
        }
    }, [success, error]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(resetPassword(token, passwordDetails));
    };

    const handleInputChange = (e) => {
        setPasswordDetails({ ...passwordDetails, [e.target.name]: e.target.value });
    };

    return loading ? (
        <Loader />
    ) : (
        <>
            <MetaData title='Reset Password' />
            <div className='loginScreen'>
                <Container>
                    <div className='formContainer'>
                        <div className='formContentSection'>
                            <SectionHeading heading={'Reset Password'} />
                            <div className='loginRegisterForm'>
                                <form onSubmit={handleSubmit}>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiFillLock />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='Password'
                                            aria-label='password'
                                            name='password'
                                            type='password'
                                            value={passwordDetails.password}
                                            onChange={handleInputChange}
                                        />
                                    </InputGroup>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiFillUnlock />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='Confirm Password'
                                            aria-label='password'
                                            name='confirmPassword'
                                            type='confirmPassword'
                                            value={passwordDetails.confirmPassword}
                                            onChange={handleInputChange}
                                        />
                                    </InputGroup>
                                    <input type='submit' value='Update' className='submitBtn' />
                                </form>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default ResetPassword;
